<template>
  <esg-base-chart>
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart type="donut"
                ref="chart"
                :width=this.width
                :height=this.height
                v-show="!loading"
                :series="series"
                :options="chartOptions"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250'
    },
    legend: {
      type: String,
      default: 'right'
    },
    scope: {
      type: Number,
      default: 1
    },
    corporation: {
      type: Object,
      default() {
        return {}
      }
    },
    businessLocation: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {
        chart: {
          fontFamily: 'NanumGothic, serif'
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: '70%',
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: '14px',
                  formatter: val => this.formatNumber(val / 10e8, 0) + ' 억원'
                },
                total: {
                  show: true,
                  label: '합계',
                  fontSize: '14px',
                  color: 'black',
                  formatter: chart => {
                    const total = chart.config.series.reduce((a, b) => a + b, 0)
                    return this.formatNumber(total / 10e8, 0) + '억원'
                  }
                },
              },
            },
          },
        },
        dataLabels: {
          background: {
            enabled: false,
          },
          dropShadow: {
            enabled: false
          }
        },
        tooltip: {
          y: {
            formatter: val => this.formatNumber(val / 10e8, 0, 2) + ' 억원'
          },
        },
        legend: {
          position: this.legend,
        },
        responsive: [],
      },
    }
  },
  watch: {
    corporation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    },
    businessLocation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        // Construct query arguments
        let args = { groupKeys: ['scope', 'abatement_method_value', 'abatement_method_name'] };
        this.corporation.name && (args.corporations = [this.corporation.code])
        this.businessLocation.name && (args.businessLocations = [this.businessLocation.business_location_code])

        let data = new FormData()
        data.append('path', 'esg/cost/main');
        data.append('json', JSON.stringify([args]));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        if (!response.data.data) {
          this.series = [];
          return
        }
        let list = JSON.parse(response.data.data)[0].data
            .filter(row => row.scope === this.scope);

        this.series = list.map(row => row.cost_total);
        this.chartOptions.labels = list.map(row => row.abatement_method_name);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
  },
}
</script>
